import GlobitsPagingSearchCustomer from "app/common/form/GlobitsPagingSearchCustomer";
import {
  pagingPatient,
  pagingPatientByNumberPhone,
} from "app/services/PatientService";
import { Form, Formik } from "formik";
import React, { forwardRef } from "react";
import Config, { CHECK_LENGTH_SEARCH_CUSTOMER } from "app/appConfig";
import {
  LIST_GENDER,
  LIST_GENDER_CRM,
  PathModule,
} from "app/common/LocalConst";
import {
  formatDisplayPhoneNumbers,
  getDateTime,
  isPhoneNumber,
  isRoleChiefTechician,
  isRoleTechician,
} from "app/common/LocalFunction";
import PatientComplainChip from "app/common/Component/PatientComplainChip";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";

export default function SelectCustomer({ variant = "standard", isMobile }) {
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          searchCustomer: "",
        }}
      >
        {({ setFieldValue, values }) => {
          return (
            <Form
              style={{ minWidth: isMobile ? 225 : 240, gap: 4 }}
              className="flex flex-middle"
            >
              {!isMobile && (
                <label style={{ color: "black", whiteSpace: "nowrap" }}>
                  Khách hàng:{" "}
                </label>
              )}

              <GlobitsPagingSearchCustomer
                name="searchCustomer"
                fullWidth
                placeholder={`Tìm kiếm theo SĐT khách (Nhập từ ${
                  CHECK_LENGTH_SEARCH_CUSTOMER
                    ? `${CHECK_LENGTH_SEARCH_CUSTOMER} kí tự trở lên)`
                    : ""
                }`}
                checkLength={CHECK_LENGTH_SEARCH_CUSTOMER}
                filterOptions={(options, state) =>
                  options.filter(
                    (option) =>
                      option?.displayName
                        ?.toLowerCase()
                        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
                      option?.phoneNumber
                        ?.toLowerCase()
                        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
                      option?.phoneNumber2
                        ?.toLowerCase()
                        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
                      option?.phoneNumber3
                        ?.toLowerCase()
                        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
                      option?.phoneNumber4
                        ?.toLowerCase()
                        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
                      option?.code
                        ?.toLowerCase()
                        .includes(state?.inputValue?.trim()?.toLowerCase()) ||
                      option?.fullName
                        ?.toLowerCase()
                        .includes(state?.inputValue?.trim()?.toLowerCase())
                  )
                }
                ListboxComponent={forwardRef((props, ref) => {
                  const { children, ...other } = props;
                  return (
                    <ul {...other} ref={ref}>
                      <ol className={"custom-listbox-customer search-customer"}>
                        <li>{children}</li>
                      </ol>
                    </ul>
                  );
                })}
                displayLabel="displayName"
                disableClearable
                renderOption={(option) => renderOptionsCustomer(option)}
                value={values?.searchCustomer || []}
                renderTags={() => ""}
                onChange={(_, value) => {
                  if (!value) return;
                  const isInTreatmentModule = window.location.pathname.includes(
                    PathModule.TREATMENT_MANAGEMENT
                  );
                  const url = isInTreatmentModule
                    ? `${Config.ROOT_PATH}${PathModule.TREATMENT_MANAGEMENT}/treatment-patient-info-detail?patientId=${value?.id}`
                    : `${Config.ROOT_PATH}${PathModule.PATIENT_MANAGEMENT}/patient-general?patientId=${value?.id}`;
                  window.open(url, "_blank");
                }}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export const renderOptionsCustomer = (patient) => {
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
        minWidth: "100px",
      }}
    >
      <div className="customer-item">
        <div className="top-row">
          <span
            className={`icon gender-icon ${
              LIST_GENDER.find((el) => el.value === patient?.gender)
                ?.className || ""
            }`}
          >
            {LIST_GENDER.find((el) => el.value === patient?.gender)?.icon || ""}
          </span>
          <span className="name">
            {patient?.displayName || patient?.fullName}
          </span>
          <span className="code">
            <CopyableCodeCell value={patient?.code} size="small" />
          </span>
        </div>
        <div className="phone">
          SĐT:{" "}
          <span style={{ fontWeight: "600", color: "#666" }}>
            {formatDisplayPhoneNumbers([
              patient?.phoneNumber,
              patient?.phoneNumber2,
              patient?.phoneNumber3,
              patient?.phoneNumber4,
            ])}
          </span>
        </div>
        <div className="flex">
          {patient?.currentPatientSourceName && (
            <div className="phone">
              Nguồn: {patient?.currentPatientSourceName}
            </div>
          )}
        </div>
        <div className="flex">
          {patient?.currentTelesaleName && (
            <div className="phone">
              Telesale:
              {patient?.currentTelesaleName || patient?.currentTelesaleName}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const renderOptionsCheckInCustomer = (patient) => {
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
        minWidth: "100px",
      }}
    >
      <div className="customer-item">
        <div className="top-row flex justify-between">
          <div className="flex gap-1 align-center">
            <span className="name">
              {patient?.saleType ? "Lead" : "KH"} :{" "}
              {patient?.displayName || patient?.fullName || ""}
            </span>
            <PatientComplainChip complainStatus={patient?.complainStatus} />
            <span className="code">
            <CopyableCodeCell value={patient?.code} size="small" />
          </span>
          </div>
          <span className="phone mt-0">
            {patient?.client ? `KH: ${patient?.client?.fullName}` : ""}
          </span>
        </div>
        <div className="phone ">
          SĐT:{" "}
          <span style={{ fontWeight: "600", color: "#666" }}>
            {formatDisplayPhoneNumbers([
              patient?.phoneNumber,
              patient?.phoneNumber2,
              patient?.phoneNumber3,
              patient?.phoneNumber4,
            ])}
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 mt-1">
          {(patient?.leadSource || patient?.currentPatientSourceName) && (
            <div className="phone">
              Nguồn:{" "}
              {patient?.leadSource?.name || patient?.currentPatientSourceName}
            </div>
          )}
          {(patient?.agent || patient?.currentTelesaleName) && (
            <div className="phone">
              Telesale:
              {patient?.agent?.staffName ||
                patient?.agent?.name ||
                patient?.currentTelesaleName}
            </div>
          )}
        </div>
        {patient?.region && (
          <div className="phone">Khu vực: {patient?.region?.name}</div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2">
          {patient?.leadDate && (
            <div className="phone">Ngày tạo lead: {getDateTime(patient?.leadDate)}</div>
          )}{patient?.assignmentTime && (
            <div className="phone">Ngày phân bổ: {getDateTime(patient?.assignmentTime)}</div>
          )}
        </div>
      </div>
    </div>
  );
};
